import React, { useState, useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { PlusCircle, ArrowLeft, User, ChevronLeft } from 'react-feather';
import {
    Box,
    Button,
    TextField,
    Typography,
    Autocomplete,
    Switch,
    Avatar,
    FormControlLabel,
    FormControl,
    Radio,
    RadioGroup,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authApi, formauthApi } from '../../api/api';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom';
import { set } from 'date-fns';
import { UploadCloud } from 'react-feather';

const seniorAttorneys = [
    { id: 1, state_name: 'John Smith (Attorney)' },
    { id: 2, state_name: 'Linda Davis (Paralegal)' },
    { id: 3, state_name: 'Michael Johnson (Attorney)' },
];

const matterCaseIds = [
    { id: 1, state_name: 'CASE-2025-001' },
    { id: 2, state_name: 'CASE-2025-002' },
    { id: 3, state_name: 'CASE-2025-003' },
];

const clients = [
    { id: 1, state_name: 'Acme Corporation' },
    { id: 2, state_name: 'John Doe' },
    { id: 3, state_name: 'Global Tech Ltd.' },
];

const familyTreeOptions = [
    { id: 1, state_name: 'Doe Family' },
    { id: 2, state_name: 'Smith Lineage' },
    { id: 3, state_name: 'Johnson Ancestry' },
];

const courts = [
    { id: 1, state_name: 'Supreme Court' },
    { id: 2, state_name: 'District Court' },
    { id: 3, state_name: 'Family Court' },
];

const clerks = [
    { id: 1, state_name: 'Jane Allen' },
    { id: 2, state_name: 'Kevin Brown' },
    { id: 3, state_name: 'Susan Clark' },
];

const judges = [
    { id: 1, state_name: 'William Black' },
    { id: 2, state_name: 'Emma White' },
    { id: 3, state_name: 'Richard Green' },
];

export default function AddClient() {
    const { id } = useParams();
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({
        full_name: '',
        senior_attorney: null,
        matter_case_id: null,
        matter_client: null,
        family_tree: null,
        court: null,
        clerk: null,
        judge: null,
        matter_background: '',
        start_date: null,
        end_date: null,
        file: null,
    });

    const [active, setActive] = useState(true);
    const [profile_image, setImageURL] = useState(null);
    const [country_code, setCountry] = useState({ id: '', name: '' })
    const [errors, setErrors] = useState({});
    const [stateOptions, setStateOptions] = useState([]);
    const [state_id, setState] = useState(null);

    const [isLoading, setIsloading] = useState(false);

    const token = useSelector((state) => state.auth.token);
   const userID = useSelector((state) => state.auth.id);

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const inputRef = useRef(null);

    // Set the default country_code on component mount
    useEffect(() => {
        const defaultCountry = countryOptions.find((option) => option.name === 'USA');
        if (defaultCountry) {
            setCountry(defaultCountry);
        }
        // listStates();

        const errorFields = Object.keys(errors);
        if (errorFields.length > 0) {
            const firstErrorField = errorFields[0];
            // You can add input refs focusing logic here if needed
        }
        
        if (userID) {
            setFormData((prevData) => ({
                ...prevData,
                login_user_id: userID,
            }));
        }
    }, [errors, userID]);

    const listStates = async () => {
        const input_token = 'STATES';
        const apiUrl = 'list_of_states';

        const dataInput = {};

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.list_of_states.map(state_id => ({
                    id: state_id.id,
                    state_name: state_id.state_name,
                    shortCode: state_id.state_short_code
                }));

                setStateOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    const countryOptions = [
        { id: 1, name: 'USA' }
    ];

    // Fixed handleChange function - separate handlers for different field types
    const handleTextChange = (field) => (event) => {
        const { value } = event.target;
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleAutocompleteChange = (field) => (event, newValue) => {
        setFormData(prev => ({ ...prev, [field]: newValue }));
    };

    const handleDateChange = (field) => (newValue) => {
        setFormData(prev => ({ ...prev, [field]: newValue }));
    };

    const handleActiveChange = (event) => {
        setActive(event.target.checked);
        setFormData(prev => ({ ...prev, status: event.target.checked }));
    };

    const handleUploadClick = () => {
        inputRef.current?.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, file: file }));
            console.log("Uploaded file:", file);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Matter Name
        if (!formData.full_name || formData.full_name.trim() === '') {
            newErrors.full_name = "Matter name is required";
        } else if (formData.full_name.length < 3) {
            newErrors.full_name = "Matter name must be at least 3 characters long";
        }

        // Senior Attorney / Paralegal
        if (!formData.senior_attorney) {
            newErrors.senior_attorney = "Senior Attorney / Paralegal is required";
        }

        // Matter Case ID
        if (!formData.matter_case_id) {
            newErrors.matter_case_id = "Matter Case ID is required";
        }

        // Matter Client
        if (!formData.matter_client) {
            newErrors.matter_client = "Matter Client is required";
        }

        // Family Tree
        if (!formData.family_tree) {
            newErrors.family_tree = "Family Tree is required";
        }

        // Court
        if (!formData.court) {
            newErrors.court = "Court is required";
        }

        // Clerk
        if (!formData.clerk) {
            newErrors.clerk = "Clerk is required";
        }

        // Judge
        if (!formData.judge) {
            newErrors.judge = "Judge is required";
        }

        // Matter Background
        if (!formData.matter_background || formData.matter_background.trim() === '') {
            newErrors.matter_background = "Matter background is required";
        }

        // Start Date
        if (!formData.start_date) {
            newErrors.start_date = "Start date is required";
        }

        // End Date
        // if (!formData.end_date) {
        //     newErrors.end_date = "End date is required";
        // } else if (formData.start_date && formData.end_date < formData.start_date) {
        //     newErrors.end_date = "End date cannot be earlier than start date";
        // }

        // File (Optional but check size/type if present)
        if (formData.file) {
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (!allowedTypes.includes(formData.file.type)) {
                newErrors.file = "File must be PDF, DOC, DOCX, XLS, or XLSX format";
            } else if (formData.file.size > maxSize) {
                newErrors.file = "File size must be less than 5MB";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event) => {
       
      event.preventDefault();

        if (!validateForm()) {
            return;
        }

        
        const addClientApi = async () => {
        
            setIsloading(true);
            const input_token = formData.full_name;
            const apiUrl = 'create_case';

            const apiData = {
                auth_token: token,
                login_user_id: userID,
                case_name: formData.full_name,
                description: formData.matter_background,
                firm_id: "13",
                client_id: formData.matter_client?.id,
                case_number: formData.matter_case_id?.state_name,
                case_type: "1",
                intake_date: formData.start_date ? formData.start_date.toISOString().split('T')[0] : "2025-07-25",
                country_id: "1",
                judge_id: formData.judge?.id,
                court_id: formData.court?.id,
                clerk_id: formData.clerk?.id,
                family_tree_id: formData.family_tree?.id,
                status: active ? 1 : 0,
                assigned_to: formData.senior_attorney?.id || "1"
            };

            try {
                const data = await authApi(input_token, apiData, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false);
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false);
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false);
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false);
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };
  addClientApi();
      
    };

    const RequiredLabel = ({ children }) => (
        <>
            {children} <span style={{ color: 'red' }}>*</span>
        </>
    );

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add New Matters
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/client"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back Matters list
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                {/* Header Section */}
                <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        Add New Matters
                    </Typography>
                    <FormControlLabel
                        control={<Switch checked={active} onChange={handleActiveChange} />}
                        label={
                            <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                Active : {active ? 'Yes' : 'No'}
                            </Typography>
                        }
                    />
                </Box>

                {/* Form Fields */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Matter Name</RequiredLabel></Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter the Matter Name"
                                value={formData.full_name}
                                error={!!errors.full_name}
                                helperText={errors.full_name}
                                onChange={handleTextChange('full_name')}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Senior Attorney / Paralegal</RequiredLabel></Typography>
                            <Autocomplete
                                options={seniorAttorneys}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.senior_attorney}
                                onChange={handleAutocompleteChange('senior_attorney')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Senior Attorney / Paralegal"
                                        variant="outlined"
                                        error={!!errors.senior_attorney}
                                        helperText={errors.senior_attorney}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Matter Case ID</RequiredLabel></Typography>
                            <Autocomplete
                                options={matterCaseIds}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.matter_case_id}
                                onChange={handleAutocompleteChange('matter_case_id')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Matter Case ID"
                                        variant="outlined"
                                        error={!!errors.matter_case_id}
                                        helperText={errors.matter_case_id}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Matter Client</RequiredLabel></Typography>
                            <Autocomplete
                                options={clients}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.matter_client}
                                onChange={handleAutocompleteChange('matter_client')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Client"
                                        variant="outlined"
                                        error={!!errors.matter_client}
                                        helperText={errors.matter_client}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Family Tree</RequiredLabel></Typography>
                            <Autocomplete
                                options={familyTreeOptions}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.family_tree}
                                onChange={handleAutocompleteChange('family_tree')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Family Tree"
                                        variant="outlined"
                                        error={!!errors.family_tree}
                                        helperText={errors.family_tree}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Court</RequiredLabel></Typography>
                            <Autocomplete
                                options={courts}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.court}
                                onChange={handleAutocompleteChange('court')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Court"
                                        variant="outlined"
                                        error={!!errors.court}
                                        helperText={errors.court}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Clerk</RequiredLabel></Typography>
                            <Autocomplete
                                options={clerks}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.clerk}
                                onChange={handleAutocompleteChange('clerk')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Clerk"
                                        variant="outlined"
                                        error={!!errors.clerk}
                                        helperText={errors.clerk}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography><RequiredLabel>Judge</RequiredLabel></Typography>
                            <Autocomplete
                                options={judges}
                                getOptionLabel={(option) => option?.state_name || ''}
                                value={formData.judge}
                                onChange={handleAutocompleteChange('judge')}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Judge"
                                        variant="outlined"
                                        error={!!errors.judge}
                                        helperText={errors.judge}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ mb: 1, fontWeight: 600 }}>Matters Details</Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <Typography sx={{ mb: 1, fontWeight: 500 }}>
                                <RequiredLabel>Matters Background</RequiredLabel>
                            </Typography>
                            <TextField
                                multiline
                                minRows={2}
                                placeholder="Enter matter background"
                                variant="outlined"
                                fullWidth
                                value={formData.matter_background}
                                onChange={handleTextChange('matter_background')}
                                error={!!errors.matter_background}
                                helperText={errors.matter_background}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: 500 }}><RequiredLabel>Start Date</RequiredLabel></Typography>
                            <DatePicker
                                value={formData.start_date}
                                onChange={handleDateChange('start_date')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        placeholder="Select start date"
                                        error={!!errors.start_date}
                                        helperText={errors.start_date}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography sx={{ mb: 1, fontWeight: 500 }}><RequiredLabel>Close Date</RequiredLabel></Typography>
                            <DatePicker
                                value={formData.end_date}
                                onChange={handleDateChange('end_date')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        placeholder="Select end date"
                                        error={!!errors.end_date}
                                        helperText={errors.end_date}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <Box
                                sx={{
                                    border: '2px dashed #ccc',
                                    borderRadius: '12px',
                                    p: 4,
                                    textAlign: 'center',
                                    backgroundColor: '#fafafa',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#1976d2',
                                    },
                                }}
                                onClick={handleUploadClick}
                            >
                                <UploadCloud size={40} color="#888" />
                                <Typography variant="body1" sx={{ mt: 1 }}>
                                    <span style={{ color: '#1976d2', textDecoration: 'underline' }}>
                                        Click to upload
                                    </span>{' '}
                                    or drag and drop
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#888', mt: 1, display: 'block' }}>
                                    Xls, PDF, Docx less than 5MB
                                </Typography>
                                <input
                                    type="file"
                                    hidden
                                    ref={inputRef}
                                    onChange={handleFileChange}
                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                />
                                {formData.file && (
                                    <Typography variant="body2" sx={{ mt: 1, color: '#1976d2' }}>
                                        Selected: {formData.file.name}
                                    </Typography>
                                )}
                            </Box>
                            {errors.file && (
                                <Typography variant="caption" sx={{ color: 'red', mt: 1, display: 'block' }}>
                                    {errors.file}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </LocalizationProvider>

                <Box mt={4} textAlign="center">
                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<PlusCircle size={20} />}
                        onClick={handleSubmit}
                        disabled={isLoading}
                        className='btn-theme-button'
                    >
                        {isLoading ? 'Adding...' : 'Add New Matters'}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}